<template>
    <div class="loginPageBody">
        <div :class="{menuPan:true, menuPan_show:menuListPanShow, menuPan_hidden:!menuListPanShow}">
          <div class="menuListPan">
            <menuList @component-selected="loadComponent"></menuList>
          </div>
          <div :class="{opFlag:true, opFlag_close:menuListPanShow,opFlag_open:!menuListPanShow}" @click="switchMenuListPan"></div>
        </div>
        <div class="mainFrame">
          <component :is="currentComponent"></component>
        </div>
    </div>
  </template>
  
  <script>
  import menuViewMap from '@/router/menuViewMap';
  import menuList from './components/menuList.vue';

  export default {
    components: {
      menuList
    },
    data(){
      return {
        //左侧菜单展示开关
        menuListPanShow : true,
        //当前显示的组件
        currentComponent: null
      }
    },
    methods:{
      switchMenuListPan(){
        this.menuListPanShow = !this.menuListPanShow;
      },
      loadComponent(componentName) {
        //从配置文件中加载页面
        var component = menuViewMap[componentName];
        this.currentComponent = component;
      }
    }
  }
  </script>
  
  <style scoped>
  /*
  1、该文件样式在/src/scss/tjmain.scss
  2、该文件被全局样式/src/global.scss导入后，全局引用
  */
  </style>